/* eslint-disable @typescript-eslint/no-explicit-any */
import Field from '@/gf/components/next/forms/Field'
import { Control, Controller, DeepPartialSkipArrayKey, UseFormReturn } from 'react-hook-form'
import { PlusIcon } from '@heroicons/react/20/solid'
import Action from '@/gf/components/Action'
import { FormValues, Part } from '../PartDetailsStep'
import PhaseCodeSelector from '@/buyers/components/PhaseCodeSelector'

const PhaseCodeForm = ({
  control,
  partIndex,
  errors,
  part,
  getDefaultPhaseCode,
}: {
  control: Control<FormValues, any>
  partIndex: number
  errors: NonNullable<UseFormReturn<FormValues, any>['formState']['errors']['parts']>[number]
  part: DeepPartialSkipArrayKey<Part>
  getDefaultPhaseCode?: () => { id: string } | null
}) => {
  return part.phaseCode ? (
    <div className="flex gap-x-4">
      <Field
        label="Phase Code"
        error={errors?.phaseCode?.id?.message}
        htmlFor={`phaseCode`}
        className="flex-grow"
      >
        <Controller
          control={control}
          name={`parts.${partIndex}.phaseCode.id`}
          render={({ field }) => (
            <PhaseCodeSelector autoFocus value={field.value} onChange={field.onChange} />
          )}
        />
      </Field>

      <Controller
        control={control}
        name={`parts.${partIndex}.phaseCode`}
        render={({ field }) => (
          <Action.T className="mt-[26px] h-8 text-sm" onClick={() => field.onChange(null)}>
            Remove
          </Action.T>
        )}
      />
    </div>
  ) : (
    <Controller
      control={control}
      name={`parts.${partIndex}.phaseCode`}
      render={({ field }) => (
        <Action.S
          onClick={() => field.onChange(getDefaultPhaseCode?.() ?? { id: null })}
          size="sm"
          className="flex gap-x-1 items-center"
        >
          <PlusIcon className="h-4 w-4 text-gray-900 inline-block" /> Add Phase Code
        </Action.S>
      )}
    />
  )
}

export default PhaseCodeForm
